/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./fb-auth-success-deligator.component.scss.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./fb-auth-success-deligator.component";
import * as i3 from "@angular/router";
import * as i4 from "../auth.service";
var styles_FbAuthSuccessDeligatorComponent = [i0.styles];
var RenderType_FbAuthSuccessDeligatorComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_FbAuthSuccessDeligatorComponent, data: {} });
export { RenderType_FbAuthSuccessDeligatorComponent as RenderType_FbAuthSuccessDeligatorComponent };
export function View_FbAuthSuccessDeligatorComponent_0(_l) { return i1.ɵvid(0, [], null, null); }
export function View_FbAuthSuccessDeligatorComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "fb-auth-success-deligator", [], null, null, null, View_FbAuthSuccessDeligatorComponent_0, RenderType_FbAuthSuccessDeligatorComponent)), i1.ɵdid(1, 114688, null, 0, i2.FbAuthSuccessDeligatorComponent, [i3.Router, i4.AuthService, i3.ActivatedRoute], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var FbAuthSuccessDeligatorComponentNgFactory = i1.ɵccf("fb-auth-success-deligator", i2.FbAuthSuccessDeligatorComponent, View_FbAuthSuccessDeligatorComponent_Host_0, {}, {}, []);
export { FbAuthSuccessDeligatorComponentNgFactory as FbAuthSuccessDeligatorComponentNgFactory };



// WEBPACK FOOTER //
// ./src/app/core/fb-auth-success-deligator/fb-auth-success-deligator.component.ngfactory.js.pre-build-optimizer.js